export default __webpack_public_path__ + "static/media/map-pin-fill.a8243a46.svg";